import React from 'react'

const EmailArrayField = (props) => {

    const styles = ({
        title: {
            fontFamily: "Arial",
            fontSize: 12,
            letterSpacing: 0.1,
            color: "#666666",
        },
        sizedBox: {
            height: 5
        },
        email: {
            fontFamily: "Arial",
            fontSize: 16,
            color: "#0072B8",
        },
    });

    const getEmails = props => {
        const emails = props.record.email ? props.record.email.split(',') : []
        return (
            <div>
                <div style={styles.sizedBox} />
                <div style={styles.title}>Emails</div>
                <div style={styles.sizedBox} />
                {emails.map((email) => <div style={styles.email}><a style={styles.email} href={`mailto:${email}`}>{email}</a></div>)}
            </div>
            )
    }

    return (getEmails(props))
}

export default EmailArrayField;